<template>
  <div class="page-container">
    <div class="page-header">
      <div class="page-title">
        센서 상세
        <span class="count-text">{{ form.name || '-' }}</span>
      </div>

      <div class="header-buttons">
        <button class="btn ghost" @click="$emit('back')">목록으로</button>
        <button class="btn primary" @click="saveSensor">저장</button>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="detail-card sensor-detail-card">
        <div class="form-row">
          <label class="form-label">센서명</label>
          <input
            v-model="form.name"
            class="control"
            type="text"
            placeholder="센서명을 입력하세요"
          />
        </div>

        <div class="form-row">
          <label class="form-label">사용여부</label>
          <div class="form-field">
            <div class="use-toggle-wrap">
              <button
                type="button"
                class="toggle-switch"
                :class="{ active: form.useYn }"
                @click="toggleUseYn"
              >
                <span class="toggle-thumb"></span>
              </button>

              <span class="toggle-text">
                {{ form.useYn ? '사용' : '미사용' }}
              </span>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">센서코드</label>
          <input
            v-model="form.code"
            class="control"
            type="text"
          />
        </div>

        <div class="form-row">
          <label class="form-label">원본키</label>
          <input
            v-model="form.rawMeasureKey"
            class="control"
            type="text"
            readonly
          />
        </div>

        <div class="form-row">
          <label class="form-label">채널번호</label>
          <input
            v-model="form.channelNo"
            class="control"
            type="text"
            readonly
          />
        </div>

        <div class="form-row">
          <label class="form-label">단위</label>
          <input
            v-model="form.unit"
            class="control"
            type="text"
          />
        </div>

        <div class="form-row">
          <label class="form-label">설치위치</label>
          <input
            v-model="form.locationDesc"
            class="control"
            type="text"
          />
        </div>

        <div class="form-row">
          <label class="form-label">설명</label>
          <textarea
            v-model="form.explain"
            class="form-textarea"
            placeholder="설명을 입력하세요"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios'

export default {
  name: 'SensorDetail',

  props: {
    sensorId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      form: {
        id: null,
        name: '',
        useYn: false,
        code: '',
        rawMeasureKey: '',
        channelNo: '',
        unit: '',
        locationDesc: '',
        explain: '',
      },
    }
  },

  mounted() {
    this.fetchDetail()
  },

  watch: {
    sensorId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.fetchDetail()
      }
    },
  },

  methods: {
    async fetchDetail() {
      this.loading = true

      try {
        const response = await api.get('/app/sensor/detail', {
          params: { id: this.sensorId },
        })

        const detail = response.data?.result

        this.form = {
          id: detail?.id ?? null,
          name: detail?.name ?? '',
          useYn: detail?.useYn ?? false,
          code: detail?.code ?? '',
          rawMeasureKey: detail?.rawMeasureKey ?? '',
          channelNo: detail?.channelNo ?? '',
          unit: detail?.unit ?? '',
          locationDesc: detail?.locationDesc ?? '',
          explain: detail?.explain ?? '',
        }
      } catch (error) {
        console.error('센서 상세 조회 실패', error)
      } finally {
        this.loading = false
      }
    },

    toggleUseYn() {
      this.form.useYn = !this.form.useYn
    },

    async saveSensor() {
      try {
        await api.post('/app/sensor/update', {
          id: this.form.id,
          name: this.form.name,
          useYn: this.form.useYn,
          code: this.form.code,
          unit: this.form.unit,
          locationDesc: this.form.locationDesc,
          explain: this.form.explain,
        })

        alert('저장되었습니다.')
        this.$emit('saved')
      } catch (error) {
        console.error('센서 저장 실패', error)
        alert('저장에 실패했습니다.')
      }
    },
  },
}
</script>

<style scoped>
@import "@/styles/admin/admin-layout.css";
@import "@/styles/admin/admin-button.css";
@import "@/styles/admin/admin-input.css";
@import "@/styles/admin/admin-form.css";
@import "@/styles/admin/admin-card.css";
@import "@/styles/admin/admin-toggle.css";

.sensor-detail-card {
  width: 100%;
  max-width: 900px;
}
</style>